import React from 'react';
import AltIso from 'alt/utils/AltIso';
import {Link} from 'react-router';
import imgResolver from '../utils/img-resolver';

import SeoActions from '../actions/SeoActions';

@AltIso.define((props) => {
    return SeoActions.pushTitle('Shift closed');
})


class FinishShiftCompleted extends React.Component {

    render() {
        const report_url = DJ_CONST.API_BASE + DJ_CONST.API.shiftReportPdf.replace('${pk}', this.props.params.shiftId);

        return (
            <div className="view-shift-completed">
                <div className="bg-img"></div>
                <div className="view-content maxwidth-wrapper">
                    <img className="" src={require('../styles/images/vasterbotten-at-night.png')} alt="" />

                    <h1>Shift is closed now! Keep up the good work!</h1>

                    <div className="buttons">
                        <a className="btn btn-green" href={report_url} target="_blank">Download timesheet</a>
                        <Link to="agenda" className="btn btn-dashboard">Go to dashboard</Link>
                    </div>
                </div>
            </div>
        );
    }
}

export default FinishShiftCompleted;



/** WEBPACK FOOTER **
 ** ./app/src/views/FinishShiftCompleted.js
 **/